// Client-side constants for the usage-telemetry contract
// (src/contracts/usage-telemetry.json v1.0, qadar-assets#220).
// Side-effect free on purpose: the drift test imports this module, so it must
// not pull in the Supabase client (which requires VITE_* env at module load).
export const USAGE_FN_PATH = "/functions/v1/admin-usage-overview";

/** Numeric metric columns of an orgs[] entry (and the fleet aggregate). Order
 *  drives the org-table column order. ext_online_now is deliberately absent in
 *  contract v1.0 — never synthesize it. */
export const ORG_USAGE_METRICS = [
  "users_total",
  "sessions_valid",
  "web_active_24h",
  "web_active_7d",
  "web_online_now",
  "ext_connected",
  "ext_active_24h",
  "ext_active_7d",
  "desktop_enrolled",
  "desktop_active_24h",
  "desktop_online_now",
] as const;

export type OrgUsageMetric = (typeof ORG_USAGE_METRICS)[number];

export type UsageCounts = Record<OrgUsageMetric, number>;

export interface OrgUsageRow extends UsageCounts {
  org_id: string;
  name: string;
}

export interface UsageOverview {
  generated_at: string;
  fleet: UsageCounts;
  orgs: OrgUsageRow[];
}

/** Fleet metric cards, in display order (issue #201). */
export const FLEET_CARD_METRICS = [
  "users_total",
  "sessions_valid",
  "web_online_now",
  "desktop_online_now",
  "web_active_24h",
  "ext_active_24h",
] as const satisfies readonly OrgUsageMetric[];

/** Adoption funnel stages, in order (issue #201). */
export const FUNNEL_STAGES = [
  "users_total",
  "ext_connected",
  "ext_active_7d",
  "desktop_enrolled",
  "desktop_active_24h",
] as const satisfies readonly OrgUsageMetric[];
